export default __webpack_public_path__ + "static/zahid_head_mob-7b102a587b2e1227c112afa904b0b7a6.png";